module.exports = __webpack_public_path__ + "img/40_00_000_807.daee0618.jpg";